import React, {useCallback, useContext, useRef, useState} from 'react';
import {ContattaciStyle} from "../../styles/pages/contact/ContattaciStyle";
import {
    Button,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Radio,
    Select,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import {useHistory} from "react-router-dom";
import {BaseStyle} from "../../styles/shared/BaseStyle";
import clsx from 'clsx';
import ArrowBackTwoToneIcon from "@mui/icons-material/ArrowBackTwoTone";
import {AppContext} from "../../App";
import {setThemeType} from "../../services/AppServices";
import Brightness4TwoToneIcon from "@mui/icons-material/Brightness4TwoTone";
import Brightness5TwoToneIcon from "@mui/icons-material/Brightness5TwoTone";
import Copyright from "../auth/utils/Copyright";
import {languages} from "../../strings/LanguageDictionary";
import DynamicFormExt from "../gestione/ticket/details/DynamicFormExt";
import useFetchReservations from "./useFetchReservations";
import {MenuProps} from "../../styles/components/DynamicComponentStyle";
import moment from "moment";
import {FasciaOrariaSelect, RenderDate1Line, RenderValue2Line} from "./PrenotazioniComponents";
import Grid from "@mui/material/Grid";
import useBackgroundImage from "../../styles/hooks/UseNewBackground";
import useDynamicForm from "../gestione/ticket/details/UseDynamicForm";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import {AddTaskTwoTone} from "@mui/icons-material";
import {BASE_NAME} from "../../services/utils/ApiUrls";
import {styled} from "@mui/material";

const CustomDivider = styled(Divider)({
    marginBottom: 20,
    marginTop: 20,
    width: "100%",
    alignItems: 'stretch',
});

const TicketPage = () => {
    let history = useHistory();
    const contattaciClasses = ContattaciStyle();
    const classes = BaseStyle();
    const appContext = useContext(AppContext);
    const [dynamicValues, setDynamicValues] = useState({});

    const [selectedService, setSelectedService] = useState("");
    const [selectedLocation, setSelectedLocation] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedFascia, setSelectedFascia] = useState(""); // Stato della fascia selezionata
    const [selectedAgenda, setSelectedAgenda] = useState(null); // Stato della fascia selezionata

    const [cliente, setCliente] = useState(false);
    const [codiceCliente, setCodiceCliente] = useState("");
    const [summary, setSummary] = useState("");
    const dynamicFormRef = useRef(null);

    const reservationStructure = 41;


    const {
        reservations,
        loadingInt,
        errorRes,
        firstLoad
    } = useFetchReservations(selectedService, selectedLocation, selectedDate);
    const {dynamicForm, loadingDyn, errorDyn} = useDynamicForm(reservationStructure);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useBackgroundImage();

    const checkDisabled = () => {
        if (selectedService === "" ||
            selectedLocation === "" ||
            selectedDate === "" ||
            selectedFascia === "" ||
            selectedAgenda === "")
            return true;

        if (cliente)
            if (codiceCliente === "")
                return true;

        return false;
    }

    const handleCreateEvent = useCallback(async () => {
        setLoading(true);
        setError(null);

        let res = true;
        if (dynamicFormRef.current) {
            res = dynamicFormRef.current.validateForm();
        }
        if (!res) {
            setLoading(false)
            return;
        }

        try {
            const response = await fetch(BASE_NAME + "reservation/create-event", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    agendaId: selectedAgenda,
                    fasciaId: selectedFascia,
                    userId: 'michele.greco',
                    codiceCliente: codiceCliente,
                    isCliente: cliente,
                    dynamicFormData: JSON.stringify(dynamicValues),
                    dynamicFormStructure: reservationStructure,
                    summary: summary ?? undefined,
                })
            });

            if (!response.ok) {
                let text = await response.json();
                window.alert(`Errore: ${text.message}`);
            } else {
                let res = await response.json();
                window.alert("Prenotazione effettuata con successo!");
                window.location.href = "https://demo.firelabs.it";
            }


        } catch (err) {
            setError(err.message);
            console.error("Errore durante la richiesta:", err);
            window.alert(`Errore: ${err.message}`);
        } finally {
            setLoading(false);
        }
    }, [selectedAgenda, selectedFascia, cliente, codiceCliente, dynamicValues, summary]);


    return (
        <React.Fragment>
            <main className={classes.mainNoBgCol}>
                <header className={contattaciClasses.header}>
                    <Tooltip
                        title={appContext.state.theme.palette.mode === "light" ? languages[appContext.state.lang].OCEAN__MAIN_GLOBAL_THEMA_TEXT : languages[appContext.state.lang].OCEAN__GLOBAL_THEMA_TEXT_DARK}>
                        <IconButton
                            className={contattaciClasses.icon}
                            color="inherit"
                            onClick={() => setThemeType(appContext.state.theme.palette.mode === "light" ? "dark" : "light", appContext.state.theme, appContext.dispatch)}
                            size="large">
                            {appContext.state.theme.palette.mode === "light" ? <Brightness4TwoToneIcon/> :
                                <Brightness5TwoToneIcon/>}
                        </IconButton>
                    </Tooltip>
                    <Typography variant="h2" component="h1" className={contattaciClasses.title}><b>Richiedi un appuntamento</b></Typography>
                </header>
                <article className={contattaciClasses.article}>
                    {(firstLoad || loadingDyn) ? <CircularProgress style={{marginTop: 50, marginBottom: 50}}/> :
                        <Paper
                            className={clsx(classes.roundBorder, contattaciClasses.mdWidth, classes.transparent80, classes.blurred20)}>


                            {!firstLoad && reservations?.length === 0 && (
                                <Grid item xs={12} className={classes.oneForColumnCentered}>
                                    <CustomDivider/>
                                    <Typography className={classes.bold}>
                                        Al momento non sono disponibili agende, si prega di riprovare più tardi.
                                    </Typography>
                                    <CustomDivider/>
                                </Grid>)}

                            {reservations?.length > 0 && (<Grid item xs={12} className={classes.oneForColumnFlexStart}>
                                <Typography className={classes.bold} style={{marginBottom: 20, fontSize: 25}}>
                                    Compila per procedere con la prenotazione:
                                </Typography>
                                <FormControl component="fieldset" style={{marginBottom: 20}}>
                                    <FormLabel component="legend">
                                        Sei già registrato? Seleziona "Sì" per recuperare rapidamente i tuoi dati e
                                        velocizzare la prenotazione.
                                    </FormLabel>
                                    <RadioGroup value={cliente}
                                                onChange={(event) => setCliente(event.target.value === "true")}
                                                row>
                                        <FormControlLabel value={true} control={<Radio color='primary'/>}
                                                          label="Si, sono già registrato"/>
                                        <FormControlLabel value={false} control={<Radio color='primary'/>}
                                                          label="No, non sono ancora registrato"/>
                                    </RadioGroup>
                                </FormControl>
                                {!cliente &&
                                    (<DynamicFormExt
                                            ref={dynamicFormRef}
                                            fields={dynamicForm}
                                            clienteCensito={false}
                                            onDataChange={setDynamicValues}/>
                                    )}

                                {cliente && (
                                    <Typography className={classes.bold}>
                                        Inserisci il codice cliente/anagrafica che ti è stato fornito
                                    </Typography>)}
                                {cliente && (<TextField
                                    variant="outlined"
                                    label="Codice Cliente"
                                    fullWidth
                                    margin="dense"
                                    required
                                    value={codiceCliente}
                                    onChange={(event) => setCodiceCliente(event.target.value.toUpperCase())}/>)}
                                <CustomDivider/>
                            </Grid>)}

                            {reservations?.length > 0 && (<Grid item xs={12} className={classes.oneForColumnFlexStart}>
                                <Typography className={classes.bold}>
                                    1. Seleziona un servizio:
                                </Typography>
                                <FormControl variant="outlined" fullWidth size="small" margin="dense">
                                    <InputLabel>Servizi disponibili *</InputLabel>
                                    <Select label={'Servizi disponibili *'} value={selectedService}
                                            onChange={(e) => setSelectedService(e.target.value)} MenuProps={MenuProps}
                                            renderValue={(selected) => (
                                                <RenderValue2Line selected={selected} clearSelection={() => {
                                                    setSelectedService('');
                                                    setSelectedLocation('');
                                                    setSelectedDate('');
                                                    setSelectedFascia('');
                                                }}/>)}>
                                        {[...new Set(reservations?.map(res => res.servizio))].map(item => (
                                            <MenuItem key={item} value={item} className={classes.menuItem2Line}>
                                                <b>{item.split(';')[0]}</b>
                                                <br/>
                                                {item.split(';')[1]}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <CustomDivider/>
                            </Grid>)}

                            {selectedService && (
                                <Grid item xs={12} className={classes.oneForColumnFlexStart}>
                                    <Typography className={classes.bold}>
                                        2. Seleziona una sede:
                                    </Typography>
                                    <FormControl variant="outlined" fullWidth size="small" margin="dense">
                                        <InputLabel>Sedi disponibili *</InputLabel>
                                        <Select label={'Sedi disponibili *'} value={selectedLocation}
                                                onChange={(e) => setSelectedLocation(e.target.value)}
                                                MenuProps={MenuProps}
                                                renderValue={(selected) => (
                                                    <RenderValue2Line selected={selected} clearSelection={() => {
                                                        setSelectedLocation('');
                                                        setSelectedDate('');
                                                        setSelectedFascia('');
                                                    }}/>)}>>
                                            {[...new Set(reservations?.map(res => res.sede))].map(item => (
                                                <MenuItem key={item} value={item} className={classes.menuItem2Line}>
                                                    <b>{item.split(';')[0]}</b>
                                                    <br/>
                                                    {item.split(';')[1]}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <CustomDivider/>
                                </Grid>
                            )}

                            {selectedLocation && (
                                <Grid item xs={12} className={classes.oneForColumnFlexStart}>
                                    <Typography className={classes.bold}>
                                        3. Seleziona una data fra quelle disponibili
                                    </Typography>
                                    <FormControl variant="outlined" fullWidth size="small" margin="dense">
                                        <InputLabel>Date disponibili *</InputLabel>
                                        <Select label={'Date disponibili *'} value={selectedDate}
                                                onChange={(e) => setSelectedDate(e.target.value)} MenuProps={MenuProps}
                                                renderValue={(selected) => (
                                                    <RenderDate1Line selected={selected} clearSelection={() => {
                                                        setSelectedDate('');
                                                        setSelectedFascia('');
                                                    }}/>)}>>
                                            {reservations?.map(res => (
                                                <MenuItem key={res.data}
                                                          value={moment(res.data).format("DDMMYYYY")}> {moment(res.data)
                                                    .locale("it")
                                                    .format("dddd D MMMM YYYY")
                                                    .replace(/^\w|\s\w/g, (c) => c.toUpperCase())}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <CustomDivider/>
                                </Grid>
                            )}

                            {selectedDate && (
                                <Grid item xs={12} className={classes.oneForColumnFlexStart}>
                                    <Typography className={classes.bold}>
                                        4. Seleziona un orario fra quelli disponibili:
                                    </Typography>
                                    <FasciaOrariaSelect
                                        reservation={reservations}
                                        selectedFascia={selectedFascia}
                                        setSelectedFascia={setSelectedFascia}
                                        setSelectedAgenda={setSelectedAgenda}
                                    />
                                    <CustomDivider/>
                                </Grid>
                            )}

                            {selectedFascia && (
                                <Grid item xs={12}>
                                    <Typography className={classes.bold}>
                                        5. Inserisci delle note o richieste aggiuntive (opzionale)
                                    </Typography>
                                    <TextField
                                        variant="outlined"
                                        label="Note"
                                        fullWidth
                                        margin="dense"
                                        multiline={true}
                                        rows={10}
                                        value={summary}
                                        onChange={(event) => setSummary(event.target.value.toUpperCase())}/>
                                </Grid>
                            )}

                            {reservations?.length > 0 && (
                                <Grid item xs={12} className={classes.oneForColumnCentered}>
                                    <Button className={clsx(classes.roundBorder, classes.margin2)}
                                            size="medium"
                                            variant="contained" color="primary"
                                            endIcon={<AddTaskTwoTone/>}
                                            disabled={checkDisabled() || loading}
                                            onClick={handleCreateEvent}>
                                        Prenota
                                    </Button>
                                </Grid>
                            )}
                        </Paper>
                    }
                    <Button className={clsx(classes.roundBorder, classes.margin2, classes.blurred20)} size="small"
                            variant="contained" color="primary" startIcon={<ArrowBackTwoToneIcon/>}
                            onClick={() => history.push('/')}>Torna alla homepage</Button>
                </article>
                <footer style={{marginTop: "8%", display: "flex", flexDirection: "column"}}><Copyright/></footer>
            </main>
        </React.Fragment>
    );
};

export default React.memo(TicketPage);
